import styled from "styled-components";

export const AvatarPerfil = styled.img`
    display: block;
    background-color: rgba(255, 255, 255, 0.5);
    width: 40%;
    max-width: 500px;
    height: auto;
`